import { useEffect, useState } from 'react';

// Same origin rule as the drone gallery: the content API is only used when
// REACT_APP_DRONE_API was set at build time. Without it the static photos stay.
const API = (process.env.REACT_APP_DRONE_API || '').replace(/\/$/, '');

// Stored files are always <id>.jpg. Anything else is not built into a URL.
const FILE_RE = /^[a-z0-9]{6,16}\.jpg$/;

const fromApi = (p) => ({
  src: `${API}/photos/${p.file}`,
  alt: typeof p.alt === 'string' && p.alt ? p.alt : null,
  legend: typeof p.caption === 'string' && p.caption ? p.caption : null,
});

// The owner-managed carousel photos, or null while loading, when there is no API,
// and on any failure or an empty list. Callers treat null as "use the built-in set",
// so the About section is never blank.
export default function useAboutPhotos() {
  const [photos, setPhotos] = useState(null);

  useEffect(() => {
    if (!API) return undefined;
    const controller = new AbortController();
    const run = async () => {
      try {
        const res = await fetch(`${API}/about.json`, { signal: controller.signal });
        if (!res.ok) return;
        const data = await res.json();
        const rows = (Array.isArray(data && data.photos) ? data.photos : [])
          .filter((p) => p && typeof p.file === 'string' && FILE_RE.test(p.file))
          .map(fromApi);
        if (!controller.signal.aborted && rows.length > 0) setPhotos(rows);
      } catch (err) {
        // Offline, blocked, aborted or malformed: keep the built-in photos.
      }
    };
    run();
    return () => controller.abort();
  }, []);

  return photos;
}
